import { render, staticRenderFns } from "./AccountStatements.vue?vue&type=template&id=20e90816&"
import script from "./AccountStatements.vue?vue&type=script&lang=js&"
export * from "./AccountStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports